import { render, staticRenderFns } from "./LaporanTukarGift.vue?vue&type=template&id=1881411b"
import script from "./LaporanTukarGift.vue?vue&type=script&lang=js"
export * from "./LaporanTukarGift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports